
import GiftCardSvc from "../../../services/gift-card-svc";
let giftCardSvc = null;
import {
  FavouriteEmployees,
  FavouriteTreatments,
  FavouriteProducts,
  TheConsents,
  OrderHistory,
  MembershipProgram,
  MySalons,
  PaymentMethods,
  Giftcards,
  NoShow,
} from "../../Profile/components";
export default {
  components: {
    FavouriteEmployees: () =>
      import(
        "../../Profile/components/FavouriteEmployees/FavouriteEmployees.vue"
      ),
    FavouriteTreatments: () =>
      import(
        "../../Profile/components/FavouriteTreatments//FavouriteTreatments.vue"
      ),
    FavouriteProducts: () =>
      import(
        "../../Profile/components/FavouriteProducts/FavouriteProducts.vue"
      ),
    TheConsents: () =>
      import("../../Profile/components/Consents/TheConsents.vue"),
    OrderHistory: () =>
      import("../../Profile/components/OrderHistory/OrderHistory.vue"),
    MembershipProgram: () =>
      import(
        "../../Profile/components/MembershipProgram/MembershipProgram.vue"
      ),
    MySalons: () => import("../../Profile/components/MySalons/MySalons.vue"),
    PaymentMethods: () =>
      import("../../Profile/components/PaymentMethods/PaymentMethods.vue"),
    Giftcards: () => import("../../Profile/components/Giftcards/Giftcards.vue"),
  },
  props: {
    user: {
      type: Object,
      required: true,
      default: null,
    },
    activeItem: {},
    hideRedirectButton: {
      required: false,
      default: false,
      type: Boolean,
    },
    layout: {
      required: false,
      default: "chain",
      type: String,
    },
    isProfile: {
      required: false,
      default: false,
      type: Boolean,
    },
    useOldNavigation: {
      required: false,
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      giftCardsCount: 0,
    };
  },
  methods: {
    switchComponent(path, item) {
      this.$emit("close-menu");
      if (this.layout == "chain") {
        this.$router
          .replace({
            query: {
              title: item
                ? item.title === "Mine besøk og bestillinger"
                  ? "bestillinger"
                  : item.title.toLowerCase().replaceAll(" ", "-")
                : path.toLowerCase().replaceAll(" ", "-"),
            },
          })
          .catch(() => {});
      } else {
        this.isProfile
          ? this.$router
              .push({
                name: item
                  ? item.title === "Ikke møtt- gebyrer"
                    ? "Ikke møtt"
                    : item.title
                  : path,
              })
              .catch(() => {})
          : window.open(
              `${process.env.VUE_APP_FIXIT_PROFILE_URL}/${
                item ? this.toUrlSafe(item.title) : this.toUrlSafe(path)
              }`,
              "_blank"
            );
      }
    },
    //OLD
    async navigate(path) {
      if (path == "logout") this.$emit("logout");
      if (this.$route.params?.chainId) {
        await this.$router
          .push(`/${path}?chainId=${this.$route.params?.chainId}`)
          .catch(() => {});
      } else if (this.$route.query?.chainId) {
        await this.$router
          .push(`/${path}?chainId=${this.$route.query?.chainId}`)
          .catch(() => {});
      } else {
        await this.$router.push(`/${path}`).catch(() => {});
      }
    },
    profileUrl() {
      return this.layout == "portal"
        ? process.env.VUE_APP_FIXIT_PROFILE_URL
        : this.$config.VUE_APP_FIXIT_PROFILE_URL
        ? this.$config.VUE_APP_FIXIT_PROFILE_URL
        : process.env.VUE_APP_FIXIT_PROFILE_URL;
    },
    toUrlSafe(string) {
      return string != ""
        ? string.toLowerCase().replaceAll(" ", "-").replaceAll("å", "aa")
        : string;
    },
    redirectToFixitProfile(path = "") {
      if (path != "") {
        window.open(
          `${this.profileUrl()}/${this.toUrlSafe(
            path === "Mine besøk og bestillinger" ? "bestillinger" : path
          )}`,
          "_self"
        );
      } else {
        window.open(
          `${this.profileUrl()}/${this.toUrlSafe(
            this.activeItem ? this.activeItem : "profil"
          )}`,
          "_self"
        );
      }
    },
    portalUrl() {
      return this.layout == "portal"
        ? process.env.VUE_APP_FIXIT_NO_URL
        : this.$config.PORTAL_URL;
    },
    isFavoriteTab(title) {
      return [
        "Favorittansatte",
        "Favorittbehandlinger",
        "Favorittprodukter",
      ].includes(title);
    },
    getDefaultFavorite() {
      return {
        title: "Favorittansatte",
        icon: "",
        component: FavouriteEmployees,
      };
    },
  },
  computed: {
    noShowCount() {
      return this.$store.getters["fairpay/getFairPayAppointmentsCount"];
    },
    lists() {
      return [
        [
          {
            title: "Mine salonger",
            visible: this.layout == "portal",
            icon: "fxt-salon",
            component: MySalons,
            oldPath: "minside/minesalonger",
          },
          {
            title: "Mine besøk og bestillinger",
            visible: true,
            icon: "fxt-cart",
            component: OrderHistory,
            oldPath: "minside/besok",
          },
          {
            title: "Favoritter",
            icon: "fxt-heart",
            visible: true,
            component: null,
            oldPath: "minside/favoritter",
          },
          {
            title: "Favorittansatte",
            visible: !this.useOldNavigation,
            icon: "",
            component: FavouriteEmployees,
            oldPath: "minside/favoritter",
          },
          {
            title: "Favorittbehandlinger",
            visible: !this.useOldNavigation,
            icon: "",
            component: FavouriteTreatments,
            oldPath: "minside/favoritter",
          },
          {
            title: "Favorittprodukter",
            icon: "",
            visible: true,
            component: FavouriteProducts,
            oldPath: "minside/favoritter",
          },
          {
            title: "Mine gavekort",
            visible: true,
            icon: "fxt-gift",
            component: Giftcards,
            oldPath: "minside/ordrehistorikk",
          }, //Not part of MVP, simple redirect to old giftcard solution
          {
            title: "Ordrehistorikk",
            visible: this.useOldNavigation,
            icon: "",
            component: null,
            oldPath: "minside/fixit-gavekort",
          },
          {
            title: "Betalingsmetoder",
            visible: this.layout == "portal",
            icon: "fxt-credit-card-checked",
            component: PaymentMethods,
            oldPath: "",
          }, //Not part of MVP
          {
            title: "Ikke møtt- gebyrer",
            visible: this.layout == "portal" && this.noShowCount > 0,
            icon: "fxt-calendar-off",
            component: NoShow,
            oldPath: "",
          },
        ],
        [
          {
            title: "Fordelsprogram",
            visible:
              this.layout == "portal" ||
              (this.$store.getters[
                "cmsConfigHomepage/getActiveCustomerPrograms"
              ] &&
                this.$store.getters[
                  "cmsConfigHomepage/getActiveCustomerPrograms"
                ].length) ||
              this.$store.dispatch(
                "reward/HasActiveCustomerProgram",
                this.$route.params.chainId
              ),
            icon: "",
            path: "",
            component: MembershipProgram,
            oldPath: "minside/fordelsprogram",
          },
          {
            title: "Personvern og samtykker",
            visible: true,
            icon: "",
            path: "",
            component: TheConsents,
            oldPath: "minside/samtykker",
          },
        ],
        [
          {
            title: "Logg ut",
            visible: true,
            icon: "",
            path: "",
            oldPath: "logout",
          },
        ],
      ];
    },
    giftCardApi() {
      return this.layout == "portal"
        ? process.env.VUE_APP_FIXIT_GIFT_CARD_API_URL
        : this.$config.VUE_APP_FIXIT_GIFT_CARD_API_URL
        ? this.$config.VUE_APP_FIXIT_GIFT_CARD_API_URL
        : process.env.VUE_APP_FIXIT_GIFT_CARD_API_URL;
    },
  },
  beforeCreate() {
    if (this.$vuetify.breakpoint.mdAndDown) {
      document.getElementsByTagName("html")[0].style.overflow = "hidden";
    }
  },
  async created() {
    giftCardSvc = await GiftCardSvc(this.$axios);
    this.giftCardsCount = await giftCardSvc.GetNumberOfActiveGiftCards(
      this.giftCardApi,
      this.layout == "chain"
        ? this.$store.getters["salon/getSiteIds"]
          ? this.$store.getters["salon/getSiteIds"]
          : this.$store.getters["site/getChainSiteIds"]
        : []
    );
  },
  beforeDestroy() {
    giftCardSvc = null;
    if (this.$vuetify.breakpoint.mdAndDown) {
      document.getElementsByTagName("html")[0].style.overflow = "auto";
    }
  },
};
